import React from 'react';
import { Form, Input, Button } from 'antd';
import { UserOutlined, LockOutlined } from '@ant-design/icons';
import https from '@/utils/ajaxUtils';
import Urls from '@/config/url';
// import allMenus from '@/config/menu';
import storageUtils from '@/utils/storageUtils';
import config from '@/config/config';
import CommonUtils from '@/utils/commonUtils.js';
import { Link } from 'react-router-dom';
import IndexHeader from '@/display/components/IndexHeader';
import IndexFooter from '@/display/components/IndexFooter';
import { connect } from 'react-redux';
//需要渲染什么数据
function mapStateToProps(state) {
  return {
    userInfo: state
  }
}
//需要触发什么行为
function mapDispatchToProps(dispatch) {
  return {
    PayIncrease: (v) => dispatch({ type: 'change', value: v }),
  }
}
class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitting: false, // 登录中
      resultMsg: null, // 错误提示
      src: null
    };
  }

  UNSAFE_componentWillMount() {
    const src = CommonUtils.getParamValue(window.location.search, 'src');
    console.log('src: ', src);
    console.log(decodeURIComponent(src));
    this.setState({
      src: decodeURIComponent(src)
    });
  }
  // 专业术语词典
  getWordDictList = async () => {
    let param = {
      currentPage: 1,
      pageSize: 9999,
    }
    let res = await https.get(Urls.getWordDictList, param);
    console.log('专业术语词典: ', res);
    if (res.success && res.data && res.data.data && res.data.data.length > 0) {
      let keyWords = res.data.data.map((v => {
        return v.word;
      }));
      return keyWords;
    }
    return null;
  }
  render() {
    console.log('login获取到的用户信息', this.props.userInfo);
    /**
     * 登录
     */
    const login = async (values) => {
      console.log(values);
      this.setState({
        resultMsg: null,
        submitting: true
      });

      // 调用接口登录
      let param = {
        password: values.password,
        username: values.username,
        projectCode: config.projectCode,
        productCode: config.productCode,
      }
      const res = await https.post(Urls.login, param);
      this.setState({
        submitting: false
      });
      console.log('登录', res);
      if (!res.success) {
        this.setState({
          resultMsg: res.errMsg
        });
        return;
      }

      const loginData = res.data;
      console.log('loginData: ', loginData);
      const { PayIncrease } = this.props;
      PayIncrease(loginData.userInfo);

      // 登录信息
      let token = {
        token: loginData.accessToken,
        refeshToken: loginData.refreshToken,
        loginInfo: loginData
      };

      // 获取用户角色信息
      const roles = loginData.roleList;
      console.log('roles: ', roles);
      const allowMenus = [];


      // 从角色中获取角色名称及菜单
      if (roles && roles.length > 0) {
        let roleNames = [];
        roles.forEach(p => {
          roleNames.push(p.name);
          if (p.menuList && p.menuList.length > 0) {
            p.menuList.forEach(k => {
              if (!allowMenus.find(o => o.id === k.id)) {
                allowMenus.push(k);
              }
            })
          }
        });
        console.log('allowMenus: ', allowMenus);
        token.roles = roleNames;
      }

      // // 处理菜单权限
      // const pages = [];
      // if (allMenus) {
      //   allMenus.forEach(p => {
      //     if (p.anonymous) {
      //       pages.push(p);
      //     } else if (allowMenus && allowMenus.length > 0) {
      //       const menu = allowMenus.find(o => o.resUrl === p.url);
      //       if (menu) {
      //         pages.push(p);
      //       }
      //     }
      //   });
      // }

      // token.pages = pages;

      // // 如果没有任何菜单
      // if (!token.pages || token.pages.length === 0 || !token.pages.find(p => p.url)) {
      //   this.setState({
      //     resultMsg: '该用户还未分配权限'
      //   });
      //   return;
      // }

      // 设置登录信息
      storageUtils.set(config.loginStorageKey, JSON.stringify(token));
      // 获取专业术语词典 缓存到local storage
      let wordDictList = await this.getWordDictList();
      console.log('wordDictList: ', wordDictList);
      storageUtils.set(config.wordDictCode, JSON.stringify(wordDictList));
      this.props.history.push('/');
      // 如果有传入src则跳转回src，否则跳转到第一个有权限的页面
      // if (this.state.src) {
      //   this.props.history.push(this.state.src);
      // } else {
      //   // const firstPage = token.pages.find(p => p.url);
      //   // this.props.history.push(firstPage.url);
      //   this.props.history.push('/');
      // }
    }


    return (
      <div id="login" className="index">
        <IndexHeader />
        <div className="main">
          <div className="box">
            <div className="form">
              <div className="login-logo"></div>
              <div>
                <div className="name">Welcome  to TWiRLs <div className="name-txt">棍棍</div></div>
                <div className="title">登录</div>
                <div className="login-form">
                  <Form
                    name="login-form"
                    onFinish={login}
                    initialValues={{ remember: true }}
                  >
                    <Form.Item
                      name="username"
                      rules={[
                        {
                          required: true,
                          message: '请输入手机号',
                        },
                      ]}
                    >
                      <Input size={'large'} placeholder="请输入手机号" className="ipt" prefix={<UserOutlined style={{ color: '#BFBFBF' }} />} />
                    </Form.Item>
                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: '请输入密码',
                        },
                      ]}
                    >
                      <Input.Password size={'large'} placeholder="请输入密码" className="ipt" prefix={<LockOutlined style={{ color: '#BFBFBF' }} />} />
                    </Form.Item>
                    <div className="acc" style={{ textAlign: 'right' }}>
                      <Link to={"/Register"}>注册账号</Link>
                    </div>
                    {/* <Form.Item name="remember" valuePropName="checked">
                    <Checkbox>自动登录</Checkbox>
                  </Form.Item> */}
                    <div className="error-tip">{this.state.resultMsg}</div>
                    <div className="btn">
                      <Button type="primary" htmlType="submit" loading={this.state.submitting}>登&nbsp;&nbsp;录</Button>
                    </div>
                    <br />
                  </Form>
                  {/* <div className="forget-password">忘记密码</div> */}
                </div>
              </div>
            </div></div>

        </div>
        <IndexFooter />
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);
